import Phaser from 'phaser';
import { PALETTE } from '../config';

/**
 * Shared top-left circular back arrow. Every screen uses this same affordance to go
 * back, so navigation is uniform (an arrow, never a text label like "Indietro").
 */
export function addBackButton(scene: Phaser.Scene, s: number, onBack: () => void): void {
  const r = Math.max(22, 24 * s);
  const x = 30 * s + r;
  const y = 30 * s + r;
  const c = scene.add.circle(x, y, r, PALETTE.ink, 0.5).setStrokeStyle(2, PALETTE.cadence, 0.6).setScrollFactor(0).setDepth(50);
  const t = scene.add.text(x, y, '‹', { fontFamily: '"Twemoji Country Flags", system-ui', fontSize: `${Math.round(34 * s)}px`, color: '#59d2ff', fontStyle: 'bold' })
    .setOrigin(0.5).setScrollFactor(0).setDepth(51);
  [c, t].forEach((o) => o.setInteractive({ useHandCursor: true }).on(Phaser.Input.Events.POINTER_DOWN, onBack));
}
